import { useState, useEffect } from 'react';

// Páginas públicas (link de agendamento de evento aberto por quem não é do time) não devem
// oferecer instalação do app.
const isRotaPublica = () => window.location.pathname.startsWith('/publico');

export default function PwaInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [isIos, setIsIos] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (isRotaPublica()) return;
    if (sessionStorage.getItem('pwa-prompt-dismissed')) return;

    const isIosBrowser =
      /iphone|ipad|ipod/i.test(navigator.userAgent) &&
      !('standalone' in window.navigator && window.navigator.standalone);

    if (isIosBrowser && !window.navigator.standalone) {
      setIsIos(true);
      setShow(true);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShow(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setShow(false);
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShow(false);
    setDismissed(true);
    sessionStorage.setItem('pwa-prompt-dismissed', '1');
  };

  if (isRotaPublica() || !show || dismissed) return null;

  return (
    <div style={styles.banner}>
      <img src="/icon-192-v3.png" alt="Inbase" style={styles.icon} />
      <div style={styles.text}>
        <strong style={styles.title}>Instalar Portal Inbase</strong>
        {isIos ? (
          <span style={styles.sub}>
            Toque em <strong>Compartilhar</strong> → <strong>Adicionar à Tela de Início</strong>
          </span>
        ) : (
          <span style={styles.sub}>Acesso rápido na tela inicial</span>
        )}
      </div>
      <div style={styles.actions}>
        {!isIos && (
          <button onClick={handleInstall} style={styles.btnInstall}>
            Instalar
          </button>
        )}
        <button onClick={handleDismiss} style={styles.btnDismiss}>✕</button>
      </div>
    </div>
  );
}

const styles = {
  banner: {
    position: 'fixed',
    bottom: 16,
    left: 16,
    right: 16,
    zIndex: 9999,
    background: '#1B3F5E',
    color: '#fff',
    borderRadius: 14,
    padding: '12px 14px',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    boxShadow: '0 4px 20px rgba(0,0,0,0.35)',
    border: '1px solid rgba(255,255,255,0.1)',
  },
  icon: { width: 44, height: 44, borderRadius: 10, flexShrink: 0 },
  text: { flex: 1, display: 'flex', flexDirection: 'column', gap: 2 },
  title: { fontSize: 14, fontWeight: 700, color: '#C9A96E' },
  sub: { fontSize: 12, color: '#94a3b8', lineHeight: 1.4 },
  actions: { display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 },
  btnInstall: {
    background: '#C9A96E',
    color: '#1B3F5E',
    border: 'none',
    borderRadius: 8,
    padding: '8px 14px',
    fontSize: 13,
    fontWeight: 700,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  btnDismiss: {
    background: 'transparent',
    color: '#94a3b8',
    border: 'none',
    fontSize: 16,
    cursor: 'pointer',
    padding: '4px 6px',
    lineHeight: 1,
  },
};
